<template>
  <IconBase :width="24" :height="24" view-box="0 0 24 24" icon-color="#9e9e9e">
    <IconHome />
  </IconBase>
</template>

<script>
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHome from "@/common/components/icons/IconHome.vue";

export default {
  components: {
    IconBase,
    IconHome
  },

  props: {}
};
</script>
